(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vl-product-main"] && !Shopify.designMode) return;
  try {
    
(function(){
function esc(s){var e=document.createElement('span');e.textContent=s==null?'':String(s);return e.innerHTML.replace(/'/g,'&#39;');}
function init(root){
if(root.dataset.ready)return;root.dataset.ready='1';
var d=(window.__vlp||{})[root.dataset.section];if(!d)return;
var fmt;try{fmt=new Intl.NumberFormat(d.loc,{style:'currency',currency:d.cur});}catch(e){fmt=new Intl.NumberFormat(undefined,{style:'currency',currency:'EUR'});}
function money(c){return fmt.format(c/100);}
var colors=d.ci>=0&&d.options[d.ci]?d.options[d.ci].values:[];
var sizes=d.si>=0&&d.options[d.si]?d.options[d.si].values:[];
var bq=d.buy+d.free,items=[];
var box=root.querySelector('[data-items]'),err=root.querySelector('[data-err]'),atc=root.querySelector('[data-atc]'),label=root.querySelector('[data-atc-label]'),note=root.querySelector('[data-note]'),track=root.querySelector('[data-track]');
if(!box||!atc)return;
var soldOut=atc.disabled;
var base=d.variants.length?d.variants[0].p:0;
function find(it){return d.variants.find(function(v){return(!colors.length||v.o[d.ci]===it.c)&&(!sizes.length||v.o[d.si]===it.s);});}
function go(i){if(!track)return;var s=track.children[i];if(s)track.scrollTo({left:s.offsetLeft,behavior:'smooth'});}
function goMedia(id){if(!track)return;var k=Array.prototype.findIndex.call(track.children,function(c){return c.dataset.media===String(id);});if(k>-1)go(k);}
if(track){
var thumbs=root.querySelectorAll('.vlp__thumb');
var cur=function(){return Math.round(track.scrollLeft/Math.max(track.clientWidth,1));};
track.addEventListener('scroll',function(){var i=cur();thumbs.forEach(function(t,k){t.classList.toggle('is-on',k===i);});},{passive:true});
thumbs.forEach(function(t){t.addEventListener('click',function(){go(Number(t.dataset.i));});});
root.querySelectorAll('.vlp__nav').forEach(function(b){b.addEventListener('click',function(){var n=track.children.length;go((cur()+Number(b.dataset.dir)+n)%n);});});
}
function price(){
var ps=items.map(function(it){var v=find(it);return v?v.p:base;}).sort(function(a,b){return b-a;});
var paid=items.length>=bq?items.length-d.free:items.length,pay=0;
for(var i=0;i<paid;i++)pay+=ps[i];
if(!soldOut)label.textContent=d.t.atc+' · '+money(pay);
}
function render(){
box.innerHTML='';
items.forEach(function(it,i){
var card=document.createElement('div');card.className='vlp__item';card.dataset.i=i;
var multi=items.length>1;
var h=`<div class='vlp__item-head'><span>${multi?d.t.item+' '+(i+1):d.t.choose}</span>${multi&&i>=items.length-d.free?`<em>${d.t.free}</em>`:''}</div>`;
if(colors.length){
h+=`<div class='vlp__row'><span class='vlp__lbl'>${esc(d.options[d.ci].name)}: <b>${esc(it.c)}</b></span><div class='vlp__sws'>`;
colors.forEach(function(c,k){h+=`<button type='button' class='vlp__sw${c===it.c?' is-on':''}' data-k='c' data-v='${k}' aria-pressed='${c===it.c}'><i class='vlp__dot' data-n='${esc(String(c).toLowerCase())}'></i>${esc(c)}</button>`;});
h+='</div></div>';
}
if(sizes.length){
h+=`<div class='vlp__row'><span class='vlp__lbl'>${esc(d.options[d.si].name)}${it.s?`: <b>${esc(String(it.s).toUpperCase())}</b>`:''}</span><div class='vlp__szs'>`;
sizes.forEach(function(s,k){var v=find({c:it.c,s:s});var off=!v||!v.a;h+=`<button type='button' class='vlp__sz${s===it.s?' is-on':''}' data-k='s' data-v='${k}' aria-pressed='${s===it.s}'${off?' disabled':''}>${esc(s)}</button>`;});
h+='</div></div>';
}
card.innerHTML=h;box.appendChild(card);
});
price();
}
function setCount(n){
items.length=Math.min(items.length,n);
while(items.length<n){var p=items[items.length-1];items.push({c:colors.length?colors[items.length%colors.length]:null,s:p?p.s:null});}
root.querySelectorAll('.vlp__opt').forEach(function(b){var on=Number(b.dataset.qty)===n;b.classList.toggle('is-on',on);b.setAttribute('aria-checked',on?'true':'false');});
if(note)note.hidden=n<bq;
err.hidden=true;
render();
}
box.addEventListener('click',function(e){
var b=e.target.closest('button[data-k]');if(!b||b.disabled)return;
var i=Number(b.closest('.vlp__item').dataset.i),it=items[i],k=b.dataset.k,val=b.dataset.v;
if(k==='c'){
it.c=colors[Number(val)];
var v=find(it);if(it.s&&(!v||!v.a))it.s=null;
var m=d.variants.find(function(x){return x.o[d.ci]===it.c&&x.m;});if(m)goMedia(m.m);
}else{
it.s=sizes[Number(val)];
items.forEach(function(o){if(!o.s){var w=find({c:o.c,s:it.s});if(w&&w.a)o.s=it.s;}});
}
err.hidden=true;render();
var f=box.querySelector(`.vlp__item[data-i='${i}'] button[data-k='${k}'][data-v='${val}']`);if(f)f.focus();
});
root.querySelectorAll('.vlp__opt').forEach(function(b){b.addEventListener('click',function(){setCount(Number(b.dataset.qty));});});
var p1=root.querySelector('[data-p1]'),pb=root.querySelector('[data-pb]');
if(p1)p1.textContent=money(base);
if(pb)pb.innerHTML='<s>'+money(base*bq)+'</s>'+money(base*d.buy);
atc.addEventListener('click',function(){
var miss=items.findIndex(function(it){return sizes.length&&!it.s;});
if(miss>-1){err.textContent=items.length>1?d.t.pickN.replace('[n]',miss+1):d.t.pick;err.hidden=false;var c=box.children[miss];if(c)c.scrollIntoView({behavior:'smooth',block:'center'});return;}
var map={};
for(var i=0;i<items.length;i++){var v=find(items[i]);if(!v||!v.a){err.textContent=d.t.sold;err.hidden=false;return;}map[v.id]=(map[v.id]||0)+1;}
var payload={items:Object.keys(map).map(function(id){return{id:Number(id),quantity:map[id]};})};
atc.disabled=true;
fetch(d.add+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)})
.then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||d.t.fail);return j;});})
.then(function(){window.location.href=d.cart;})
.catch(function(e){err.textContent=e.message||d.t.fail;err.hidden=false;atc.disabled=false;});
});
var st=root.querySelector('[data-sticky]'),offer=root.querySelector('.vlp__offer');
if(st&&offer&&'IntersectionObserver' in window){new IntersectionObserver(function(en){st.hidden=en[0].isIntersecting;}).observe(offer);}
setCount(bq);
}
document.querySelectorAll('.vlp').forEach(init);
document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.vlp');if(r)init(r);});
})();

  } catch(e) { console.error(e); }
})();
})();
